module.exports = __webpack_public_path__ + "static/media/lokmanyamob-3.8b08bd7d.png";